/**
 * The institute's social accounts.
 *
 * LinkedIn and Facebook are taken from the institute's own footer at
 * bietdvg.edu, which is the authoritative source — a plain search turns up
 * four competing "BIET Davangere" Facebook pages and there is no way to tell
 * from search alone which one the institute runs.
 *
 * The YouTube channel was supplied directly and verified to resolve (HTTP 200).
 * Note that bietdvg.edu's own footer links a single video rather than this
 * channel — the wrong target for a "Follow" link, and worth fixing there.
 *
 * Instagram and X are left empty because bietdvg.edu links neither.
 *
 * PASTE ANY REMAINING URLS BELOW. An entry with an empty `url` is skipped
 * everywhere it would render, so an unfilled account never ships as a dead
 * link — the block simply shows one fewer item, and disappears entirely if no
 * account has a URL yet. That is deliberate: a social row that links nowhere
 * is worse than no social row.
 */

export type SocialPlatform =
  | "instagram"
  | "linkedin"
  | "youtube"
  | "facebook"
  | "x";

export interface SocialAccount {
  platform: SocialPlatform;
  /** Shown to readers, and used as the accessible name. */
  label: string;
  /** Full absolute URL. Leave "" until the account is confirmed. */
  url: string;
}

export const SOCIAL: SocialAccount[] = [
  { platform: "instagram", label: "Instagram", url: "" },
  { platform: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/school/bapuji-institute-of-engineering-&-technology-davanagere/" },
  { platform: "youtube", label: "YouTube", url: "https://www.youtube.com/@BIETDavangere-up7lx" },
  { platform: "facebook", label: "Facebook", url: "https://www.facebook.com/BapujiInstituteOfEngineeringTechnology" },
  { platform: "x", label: "X", url: "" },
];

/**
 * Only the accounts that actually have a URL. Every consumer reads through
 * this rather than SOCIAL directly, so an unfilled entry cannot leak into the
 * page as a link to nowhere.
 */
export function activeSocial(accounts: SocialAccount[] = SOCIAL): SocialAccount[] {
  return accounts.filter((a) => a.url.trim() !== "");
}
